import { IntralinksAccountInfo } from '../../tamalelibs/models/intralinks.model';

export class IntralinksMappingDialogParam {
    treeItems: any[];
    account: IntralinksAccountInfo;
    selectedFolderId: string;
    screenId: string;
}
